import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';

export default function ArticlesPreview() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight">
            {t('articles.title')}
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            {t('articles.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
          {articles.map((article) => (
            <a
              key={article.id}
              href={`/articles/${article.slug}/`}
              className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-300 hover:shadow-lg transition-all"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-medium text-foreground-700">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-5 md:p-6">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span>{article.date}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300" />
                  <span>{article.readTime}</span>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 leading-snug mb-3 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  {t('articles.readMore')}
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/articles/allchinabuy-spreadsheet-complete-guide/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-sm font-medium text-foreground-700 hover:bg-background-50 hover:border-foreground-300 transition-colors"
          >
            {t('articles.allArticles')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}